import { isColumnVisibleByDefault } from '../../../../utils/partialPermissionUtils';
import renderResponsible from './renderResponsible.js';
import { capitalize } from 'lodash';

let responsibleList = [];

const responsibleCol = (
  gantt,
  t,
  fieldNoPermission,
  triggerSetter,
  cursorCustomStyle,
  subContracts
) => {
  const columnName = 'responsables';

  const columnDefinition = {
    name: columnName,
    label: 'Responsable',
    data_type: 'array/images',
    visible: true,
    span: 2,
    offset: 0,
    align: 'center',
    from_values: 'toSelectResponsables',
    hide: !isColumnVisibleByDefault(columnName),
    width: 125,
    groupable: false,
    orderable: false,
    filterable: true,
    resize: true,
    el_to_extract_from: 'email',
    el_to_label_from: ['name', 'lastname'],
    img_from: 'image',
    template: (task) => {
      return renderResponsible({
        column: columnDefinition,
        gantt,
        t,
        onlyRead: fieldNoPermission,
        task,
        mainObject: {},
        customMainClassName: '',
        responsibleList: gantt.toSelectResponsables,
        subContracts
      });
    },
    templateExportable: (task) => {
      const currentGantt = window.to_use_react_gantt;
      if (!currentGantt) return '';
      let isOdd = false;
      if (currentGantt.oddColsConfig) {
        isOdd = currentGantt.oddColsConfig.responsables;
      }

      let insideHtml = '';
      task.responsables.map((responsable, index) => {
        insideHtml += `<span className='name-responsable-pdf'>
                                  ${responsable.name ? capitalize(responsable.name) : ''} ${responsable.lastname ? capitalize(responsable.lastname) : ''}${task.responsables.length > 1 && parseInt(task.responsables.length) - 1 !== index ? ', ' : ''}
                                  </span>`;
        return null;
      });

      const findColumn = window.to_use_react_gantt.config.columns.find(
        (el) => el.name === 'responsables'
      );
      const w1 = parseInt(findColumn.width);

      return `
              <div class="${isOdd ? 'odd-col' : 'non-odd-col'}">
                  <span class="string-h" style="width: ${w1}px;">
                      ${insideHtml}
                  </span>
              </div>
          `;
    }
  };
  return columnDefinition;
};

export default responsibleCol;
